<template>
  <div class="container-action-history flex items-center">
    <div
      class="action-history-item"
      :class="{'disable' : disableUndoItem}"
      @click="undoAction"
      v-tooltip="isMobile ? false : {html: true, content: tooltipHoverUndo}"
    >
      <svg
        :class="{'disable' : disableUndoItem}"
        class="action-history undo-action-history"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.54232 5.59031C1.34462 5.39464 1.34462 5.07524 1.54232 4.87957L4.06976 2.37805C4.38548 2.06557 4.92149 2.28921 4.92149 2.73342V4.52291H10.0838C12.2466 4.52291 14 6.27627 14 8.43914C14 10.602 12.2466 12.3554 10.0838 12.3554H6.87958C6.48633 12.3554 6.16754 12.0366 6.16754 11.6433C6.16754 11.2501 6.48633 10.9313 6.87958 10.9313H10.0838C11.4601 10.9313 12.5759 9.81551 12.5759 8.43914C12.5759 7.06276 11.4601 5.94699 10.0838 5.94699H4.92149V7.73645C4.92149 8.18067 4.38548 8.40431 4.06976 8.09183L1.54232 5.59031Z"
          fill="#282E3E"
        />
      </svg>
    </div>
    <div
      class="action-history-item"
      :class="{'disable' : disableRedoItem}"
      @click="redoAction"
      v-tooltip="isMobile ? false : {html: true, content: tooltipHoverRedo}"
    >
      <svg
        :class="{'disable' : disableRedoItem}"
        class="action-history redo-action-history"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.4577 5.59031C14.6554 5.39464 14.6554 5.07524 14.4577 4.87957L11.9302 2.37805C11.6145 2.06557 11.0785 2.28921 11.0785 2.73342V4.52291H5.91623C3.75336 4.52291 2 6.27627 2 8.43914C2 10.602 3.75336 12.3554 5.91623 12.3554H9.12042C9.51367 12.3554 9.83246 12.0366 9.83246 11.6433C9.83246 11.2501 9.51367 10.9313 9.12042 10.9313H5.91623C4.53986 10.9313 3.42408 9.81551 3.42408 8.43914C3.42408 7.06276 4.53986 5.94699 5.91623 5.94699H11.0785V7.73645C11.0785 8.18067 11.6145 8.40431 11.9302 8.09183L14.4577 5.59031Z"
          fill="#282E3E"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Util from '@/util'

export default {
  name: 'ControlActionHistories',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState([
      'undoHistory',
      'redoHistory',
      'isBlockHistory',
      'isSyncing',
      'isDisableEditPresentation',
      'canEditPresentation',
    ]),
    disableUndoItem() {
      return !this.undoHistory.length || this.isBlockHistory || this.isSyncing !== 2 || !this.canEditPresentation
    },
    disableRedoItem() {
      return !this.redoHistory.length || this.isBlockHistory || this.isSyncing !== 2 || !this.canEditPresentation
    },
  },
  watch: {
    isDisableEditPresentation(value) {
      if (value) {
        this.clearHistory()
      }
    },
  },
  methods: {
    ...mapActions([
      'undoAction',
      'redoAction',
      'clearHistory',
    ]),
    detectIOS() {
      return Util.isMacOS()
    },
    getCommand() {
      return this.detectIOS() ?
        '<div class="shortcut-key">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">\n' +
          '<rect x="0.622314" y="0.5" width="17.9971" height="18" rx="4" fill="#3F4557"/>\n' +
          '<path d="M6.28856 4.52362C5.85481 4.60564 5.50705 4.78742 5.2101 5.08631C4.41104 5.88343 4.42859 7.16897 5.25111 7.9466C5.4992 8.18306 5.79034 8.34516 6.13422 8.43697C6.32375 8.48583 6.35303 8.48777 6.98019 8.49756L7.62888 8.50542V9.49789V10.4904L6.98019 10.5001C6.48585 10.508 6.29835 10.5177 6.20256 10.5392C5.4231 10.7267 4.84479 11.3011 4.66699 12.067C4.61231 12.2976 4.61619 12.7294 4.67484 12.9619C4.76472 13.3214 4.92498 13.6106 5.1848 13.8802C5.98191 14.7066 7.28123 14.7027 8.07049 13.8685C8.30685 13.6204 8.46905 13.3292 8.56086 12.9853C8.60972 12.7958 8.61166 12.7665 8.62145 12.1394L8.62931 11.4907H9.62177H10.6142L10.624 12.1413C10.6338 12.8133 10.6416 12.8955 10.7315 13.1514C10.8995 13.632 11.2726 14.058 11.7239 14.2826C12.5152 14.6754 13.4374 14.519 14.0489 13.8899C14.3966 13.5323 14.5842 13.1103 14.6154 12.6141C14.6721 11.7329 14.1153 10.8987 13.2752 10.6077C13.0193 10.5178 12.9372 10.5099 12.2651 10.5002L11.6145 10.4905V9.49799V8.50552L12.2651 8.49767C12.8884 8.48787 12.9215 8.48594 13.1091 8.43707C14.6331 8.03464 15.1332 6.14927 14.004 5.06101C13.7344 4.80119 13.4453 4.64093 13.0857 4.55106C12.8532 4.4924 12.4214 4.48853 12.1908 4.54321C11.4249 4.72101 10.8506 5.29931 10.663 6.07888C10.6415 6.17457 10.6318 6.36217 10.6239 6.85457L10.6141 7.5052H9.62167H8.6292L8.62135 6.85457C8.61156 6.23129 8.60962 6.19813 8.56076 6.01053C8.36928 5.28768 7.82026 4.74254 7.09149 4.553C6.89032 4.50016 6.48595 4.48649 6.28856 4.52362ZM6.80045 5.51415C7.16188 5.57862 7.4725 5.86384 7.58196 6.22527C7.61317 6.32687 7.61715 6.42062 7.61909 6.91884V7.4952H7.04273C6.5445 7.49327 6.45076 7.48939 6.34915 7.45807C5.86266 7.31158 5.55204 6.82509 5.63406 6.3386C5.7024 5.93811 6.01701 5.60596 6.40577 5.5219C6.55624 5.48875 6.65396 5.48681 6.80045 5.51415ZM12.8278 5.51996C13.3397 5.62942 13.6933 6.13927 13.6093 6.64729C13.5468 7.02636 13.2771 7.33698 12.9157 7.45226C12.7848 7.49327 12.7438 7.4952 12.2006 7.4952H11.6243V6.91884C11.6243 6.37573 11.6262 6.33462 11.6672 6.20374C11.7746 5.86578 12.0658 5.59616 12.4018 5.5219C12.5601 5.48681 12.6696 5.48681 12.8278 5.51996ZM10.6181 9.49789V10.4943H9.62167H8.62523V9.49789V8.50144H9.62167H10.6181V9.49789ZM7.61909 12.0768C7.61909 12.6199 7.61715 12.661 7.57614 12.7919C7.42772 13.2609 6.95683 13.5598 6.4781 13.4874C5.93693 13.4034 5.55591 12.8974 5.63212 12.3621C5.69465 11.9264 6.02874 11.5844 6.46249 11.5122C6.5191 11.5024 6.80249 11.4966 7.09159 11.4985L7.61909 11.5005V12.0768ZM12.9254 11.5454C13.3884 11.6978 13.6815 12.1686 13.6112 12.6415C13.5272 13.1826 13.0114 13.5695 12.4781 13.4855C12.103 13.4289 11.7884 13.1612 11.6692 12.8017C11.6302 12.6845 11.6263 12.6239 11.6184 12.1101C11.6146 11.8014 11.6165 11.5337 11.6223 11.5181C11.6321 11.4908 11.7043 11.4888 12.2162 11.4947C12.7477 11.5024 12.8082 11.5063 12.9254 11.5454Z" fill="white"/>\n' +
          '</svg>' +
          '</div>' :
        '<div class="shortcut-key short-key-ctrl">Ctrl</div>'
    },
    tooltipHoverUndo() {
      const command = this.getCommand()
      const textUndo = this.$i18nPresenter.t('Undo')
      return `${`${'<div class="tooltip-hover-action-history">' +
      `<span class="tooltip-action-history-title">${textUndo}</span>` +
      '<div class="container-shortcut-key">'}${
        command
      }<div class="shortcut-key">` +
      '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">\n' +
      '<rect x="0.616455" y="0.5" width="18" height="18" rx="4" fill="#3F4557"/>\n' +
      '<path d="M7.01729 14.0128C6.74434 14.0128 6.53756 13.9403 6.39695 13.7952C6.26461 13.6416 6.20671 13.4453 6.22326 13.2063C6.24807 12.9673 6.35146 12.7198 6.53342 12.4638L10.9006 6.35714H6.89322C6.42176 6.35714 6.18604 6.1267 6.18604 5.66582C6.18604 5.21348 6.42176 4.9873 6.89322 4.9873H12.0296C12.3025 4.9873 12.5052 5.06412 12.6375 5.21774C12.7781 5.36284 12.8402 5.55487 12.8236 5.79384C12.8071 6.02428 12.7037 6.27179 12.5135 6.53637L8.1463 12.643H12.3398C12.8112 12.643 13.047 12.8692 13.047 13.3215C13.047 13.7824 12.8112 14.0128 12.3398 14.0128H7.01729Z" fill="white"/>\n' +
      '</svg>' +
      '</div>' +
      '</div>' +
      '</div>'
      }`
    },
    tooltipHoverRedo() {
      const command = this.getCommand()
      const textRedo = this.$i18nPresenter.t('Redo')
      return `${'<div class="tooltip-hover-action-history">' +
          `<span class="tooltip-action-history-title">${textRedo}</span>` +
          '<div class="container-shortcut-key">'}${
        command
      }<div class="shortcut-key">` +
          '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">\n' +
          '<rect x="0.619385" y="0.5" width="17.9971" height="18" rx="4" fill="#3F4557"/>\n' +
          '<path d="M4.31511 9.71158L4.24248 9.78032C4.31776 9.85985 4.41787 9.89996 4.51743 9.90175C4.52228 9.90246 4.52745 9.90288 4.53291 9.90288H6.82761V14.5912C6.82761 14.8114 7.00658 14.9904 7.22681 14.9904H12.0151C12.2367 14.9904 12.4143 14.8112 12.4143 14.5912V9.90178H14.709C14.9292 9.90178 15.1082 9.72281 15.1082 9.50258C15.1082 9.44753 15.0968 9.39557 15.0771 9.34838C15.0594 9.29996 15.0319 9.24847 14.9876 9.20417L14.9875 9.20408L9.91407 4.1438C9.91098 4.13946 9.90707 4.13462 9.90232 4.12987L9.83161 4.20058M4.31511 9.71158L4.2431 9.78097C4.08935 9.62142 4.0889 9.36405 4.24342 9.20516L4.24454 9.20401L4.24455 9.20402L9.32701 4.14352C9.33033 4.1388 9.33415 4.13422 9.3385 4.12987L9.40921 4.20058M4.31511 9.71158C4.37341 9.77318 4.45151 9.80288 4.52851 9.80178L4.31511 9.27488C4.19851 9.39478 4.19851 9.59058 4.31511 9.71158ZM9.40921 4.20058L9.3372 4.13119C9.41494 4.05053 9.51798 4.01057 9.61969 4.01038M9.40921 4.20058C9.40853 4.20126 9.40827 4.20194 9.40791 4.20288C9.40769 4.20346 9.40743 4.20414 9.40701 4.20498L9.40921 4.20058ZM9.61969 4.01038C9.72341 4.00908 9.82658 4.05125 9.90362 4.13119L9.83161 4.20058M9.61969 4.01038C9.61993 4.01038 9.62017 4.01038 9.62041 4.01038V4.11038M9.61969 4.01038C9.61944 4.01038 9.6192 4.01039 9.61896 4.01039L9.62041 4.11038M9.83161 4.20058C9.83271 4.20168 9.83326 4.20278 9.83381 4.20388C9.83436 4.20498 9.83491 4.20608 9.83601 4.20718L9.62041 4.11038M9.83161 4.20058C9.77331 4.14008 9.69631 4.10928 9.62041 4.11038M9.92277 4.15818C9.92321 4.15902 9.92337 4.15939 9.92326 4.15916L9.92314 4.15892C9.92305 4.15874 9.92293 4.15849 9.92277 4.15818ZM12.0151 9.10338C11.7949 9.10338 11.6159 9.28235 11.6159 9.50258V14.1909H7.62601V9.50258C7.62601 9.28235 7.44704 9.10338 7.22681 9.10338H5.48901L9.62036 4.99073L13.7455 9.10338H12.0151Z" fill="white" stroke="white" stroke-width="0.2"/>\n' +
          '</svg>' +
          '</div>' +
          '<div class="shortcut-key">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">\n' +
          '<rect x="0.616455" y="0.5" width="18" height="18" rx="4" fill="#3F4557"/>\n' +
          '<path d="M7.01729 14.0128C6.74434 14.0128 6.53756 13.9403 6.39695 13.7952C6.26461 13.6416 6.20671 13.4453 6.22326 13.2063C6.24807 12.9673 6.35146 12.7198 6.53342 12.4638L10.9006 6.35714H6.89322C6.42176 6.35714 6.18604 6.1267 6.18604 5.66582C6.18604 5.21348 6.42176 4.9873 6.89322 4.9873H12.0296C12.3025 4.9873 12.5052 5.06412 12.6375 5.21774C12.7781 5.36284 12.8402 5.55487 12.8236 5.79384C12.8071 6.02428 12.7037 6.27179 12.5135 6.53637L8.1463 12.643H12.3398C12.8112 12.643 13.047 12.8692 13.047 13.3215C13.047 13.7824 12.8112 14.0128 12.3398 14.0128H7.01729Z" fill="white"/>\n' +
          '</svg>' +
          '</div>' +
          '</div>' +
          '</div>'
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

@media (max-width: 768px) {
  .container-action-history {
    display: none;
  }
}

.container-action-history {
  align-content: center;

  .action-history-item {
    padding: 4px;

    &:hover {
      &:not(.disable) {
        path{
          fill: $primary-color
        }
        cursor: pointer;
        background: #EFF1F7;
        border-radius: 3px;
      }

      .disable {
        cursor: no-drop;
      }
    }

    &:first-child {
      margin-right: 4px;
    }

    .action-history {
      color: #191F2D;

      &.disable {
        opacity: 0.3;
      }
    }
  }
}
</style>
